/**
 * Safe error logging utility that prevents sensitive data leakage in production
 */

const isDevelopment = import.meta.env.DEV;

// Generic user-facing error message
export const GENERIC_ERROR_MESSAGE = "Oops, Perchly is behaving erratic. Please try again later";

export const logError = (context: string, error: unknown): void => {
  if (isDevelopment) {
    // Full error details in development
    console.error(context, error);
  } else {
    // Sanitized message in production
    const safeMessage = error instanceof Error ? error.message : 'An error occurred';
    console.error(`${context}: ${safeMessage}`);
  }
};

export const logWarning = (context: string, message: string): void => {
  if (isDevelopment) {
    console.warn(context, message);
  }
};

export const logInfo = (context: string, message: string): void => {
  if (isDevelopment) {
    console.log(context, message);
  }
};

/**
 * Get user-friendly error message
 * In development, shows detailed error; in production, shows generic message
 */
export const getUserFriendlyError = (error?: unknown): string => {
  if (isDevelopment && error instanceof Error) {
    return error.message;
  }
  return GENERIC_ERROR_MESSAGE;
};
